// src/menu-items/statistics.ts
import { Plus, Building } from 'iconoir-react';


const wholesales = {
  id: 'wholesales-group',
  title: 'Wholesales',
  type: 'group',
  children: [
    {
      id: 'wholesales-search',
      title: 'Wholesales',
      type: 'item',
      url: '/wholesales/search',
      icon: Building,
      breadcrumbs: true
    },
    {
      id: 'wholesales-create',
      title: 'Create Wholesale',
      type: 'item',
      url: '/wholesales/add',
      icon: Plus,
      breadcrumbs: true
    }
  ]
};

export default wholesales;
